import Component from './component';
// Convert default export to named export
export const AccountFundEmpty = Component;
